<div class="modal-header">
    <h4 class="modal-title">{{ 'studyQualityEvaluation_changeConditionTitle' | translate }}</h4>
</div>

<div class="modal-body">
    <form #form="ngForm">
        <div class="form-field required">
            <label class="form-label">{{ 'studyQualityEvaluation_lblResidencyCondition' | translate }}</label>
            <textarea class="form-control" name="residencyCondition" [(ngModel)]="model.ResidencyCondition" required maxlength="4000"></textarea>
        </div>

        <div class="form-field required">
            <label class="form-label">{{ 'studyQualityEvaluation_lblResidencyDeadline' | translate }}</label>
            <app-date [(ngModel)]="model.ResidencyDeadline" name="residencyDeadline" required></app-date>
        </div>
    </form>
</div>

<div class="modal-footer">
    <button class="btn btn-outline-secondary" type="button" (click)="cancel()" [disabled]="isSaving">{{'cancel' | translate}}</button>

    <button class="btn btn-primary" (click)="save()" type="button" [disabled]="isSaving">
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="isSaving"></span>
        {{'save' | translate}}
    </button>

    <button class="btn btn-outline-primary" (click)="save(true)" type="button" [disabled]="isSaving">
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="isSubmitting"></span>
        <i class="fi fi-rs-paper-plane" *ngIf="!isSubmitting"></i>
        {{'submit' | translate}}
    </button>
</div>
